import { render, staticRenderFns } from "./delayButton.vue?vue&type=template&id=37776a22&scoped=true"
import script from "./delayButton.vue?vue&type=script&lang=js"
export * from "./delayButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37776a22",
  null
  
)

export default component.exports